import React, { useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { GamifyIcon } from '../../../components/GamifyIcon';
import { LeaderboardStackView } from '../../../store/zustand/useLeaderboardStore';

interface StackBreadCrumbProps {
  viewsStack: LeaderboardStackView[];
  onStackClick: (index: number) => void;
}

const StackBreadCrumb: React.FC<StackBreadCrumbProps> = ({
  viewsStack,
  onStackClick,
}) => {
  const [loadingIndex, setLoadingIndex] = useState<number | null>(null);

  const handleStackClick = (index: number) => {
    if (index === viewsStack.length - 1) {
      return;
    }

    setLoadingIndex(index);
    onStackClick(index);

    // Reset loading state after a short delay
    setTimeout(() => setLoadingIndex(null), 1000);
  };

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 5,
        marginLeft: 10,
      }}
    >
      {viewsStack.map((view: LeaderboardStackView, index: number) => (
        <React.Fragment
          key={`${view.circleName || view.circleLevelName}-${index}`}
        >
          <div
            onClick={() => handleStackClick(index)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 4,
            }}
          >
            <h4
              style={{
                color: index === viewsStack.length - 1 ? '#808080' : '#ff6a00',
                cursor: index === viewsStack.length - 1 ? 'default' : 'pointer',
                opacity: loadingIndex === index ? 0.7 : 1,
                transition: 'opacity 0.2s ease',
              }}
            >
              {view.circleName || view.circleLevelName}
            </h4>
            {loadingIndex === index && (
              <CircularProgress size={12} sx={{ color: '#ff6a00' }} />
            )}
          </div>
          {index !== viewsStack.length - 1 && (
            <GamifyIcon icon="rightArrow" color="#ff6a00" />
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default StackBreadCrumb;
